import {VerticalSpacer} from "@vesta/global-common-typescript/components/verticalSpacer";

// Types of components
//     Page title
//     Section title
//     Form row
//     Action button

// Spacing
//     Page title-form: h-ds-space-200 sm:h-ds-space-300
//     Page title-section title: h-ds-space-200 sm:h-ds-space-300
//     Form-form: h-ds-space-200
//     <!-- TODO: Maybe this should be `h-ds-space-200 sm:h-ds-space-300`? -->
//     Section title-form: h-ds-space-200

export function AnankeTempVerticalSpacer({
    above,
    below,
}: {
    above: "pageTitle" | "sectionTitle" | "formRow" | "actions" | "collapsibleSectionStart" | "collapsibleSectionEnd";
    below: "pageTitle" | "sectionTitle" | "formRow" | "actions" | "collapsibleSectionStart" | "collapsibleSectionEnd";
}) {
    if (above === "pageTitle") {
        return <VerticalSpacer className="h-ds-space-200 sm:h-ds-space-300" />;
    }

    if (above === "formRow" && below === "formRow") {
        return <VerticalSpacer className="h-ds-space-100" />;
    }

    return <VerticalSpacer className="h-ds-space-200" />;
}
